module.exports = __webpack_public_path__ + "img/Horologium.a7581d7f.png";